import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";
import validate from "../../common/validation";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { categoriTypes } from "../StaticData.js";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import moment from "moment/moment";
import {
  addFillerStock,
  getCubeBelts,
  getInclusion,
  getUserApi,
  updateGraderAssignStock,
} from "api";
import { withTranslation } from "react-i18next";
import ShowDiffenence from "components/Common/ShowDiffenence";

class FillerEditVerifyAndAccept extends Component {
  constructor(props) {
    let assignGraderToFillerInWards =  props?.location?.query?.data.assignGraderToFillerInWards;
    if(props.location.query?.isEdit == 1 &&props.location.query?.data.fillerStock !== null){
      const stockFillerInWardsInfo = props?.location?.query?.data?.fillerStock?.stockFillerInWards?.map((x)=>x.assignGraderToFillerInWardId);
      const assignGraderToFillerInWardsInfo = props?.location?.query?.data?.assignGraderToFillerInWards?.filter((x)=> !stockFillerInWardsInfo.includes(x.id));
      assignGraderToFillerInWards= assignGraderToFillerInWardsInfo;
    }
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      editRowIndex: -1,
      fillerList: [],
      stockList: [],
      inclusionList: [],
      props: props?.location?.query,
      notEditableRows:
        props.location.query?.isEdit == 1
          ? assignGraderToFillerInWards
              .filter(x => x.stockGraderInWard.ar == true)
              .map(x => x.id)
          : props?.location?.query?.data?.stockFillerInWards.map(x => x.id),
      stockList:
        props.location.query?.isEdit == 1
          ? assignGraderToFillerInWards
              .filter(x => x.stockGraderInWard.ar == true && x.stockGraderInWard.forward_status == "f")
              .sort(
                (a, b) =>
                  a.stockDataEntryInWard.srNo - b.stockDataEntryInWard.srNo
              )
              .map((x, index) => {
                return {
                  id: index + 1,
                  assignGraderToFillerStockId: props?.location?.query?.data.id,
                  assignGraderToFillerInWardId: x.id,
                  remarks: x.nextRemarks,
                  weight: x.weight,
                  weightType: x.weightType,
                  stockDataEntryInWardId: x.stockDataEntryInWardId,
                  stockGraderInWardId: x.stockGraderInWardId,
                  srNo: x.stockDataEntryInWard.srNo,
                  pieces: x.stockDataEntryInWard.pieces,
                  inclusionId: x.stockGraderInWard.inclusionId,
                  shape: x.stockGraderInWard.shape.name,
                  processId: x.process.name,
                };
              })
          : props?.location?.query?.data.stockFillerInWards
              .sort(
                (a, b) =>
                  a.stockDataEntryInWard.srNo - b.stockDataEntryInWard.srNo
              )
              .map((x, index) => {
                return {
                  id: index + 1,
                  assignGraderToFillerStockId: props?.location?.query?.data.id,
                  assignGraderToFillerInWardId: x.id,
                  remarks: x.nextRemarks,
                  weight: x.stockDataEntryInWard.weight,
                  weightType: x.weightType,
                  stockDataEntryInWardId: x.stockDataEntryInWardId,
                  stockGraderInWardId: x.stockGraderInWardId,
                  srNo: x.stockDataEntryInWard.srNo,
                  pieces: x.stockDataEntryInWard.pieces,
                  inclusionId: x.stockGraderInWard.inclusionId,
                  shape: x.stockGraderInWard.shape.name,
                  processId: x.assignGraderToFillerInWard.process.name,
                };
              }),
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async handleSubmit(e, values) {
    e.preventDefault();
    if (this.state.props.isEdit == 1) {
      let temp = {
        mainJangadId: this.state.props.data.mainJangadId,
        jangadId: this.state.props.data.jangadId,
        dataEntryStockId: this.state.props.data.dataEntryStockId,
        graderStockId: this.state.props.data.graderStockId,
        remarks: values.remarks,
        assignGraderToFillerStockId: this.state.props.data.id,
        stockFillerInWards: this.state.stockList.map((x, index) => {
          return {
            id: index + 1,
            stockGraderInWardId: x.stockGraderInWardId,
            assignGraderToFillerStockId: x.assignGraderToFillerStockId,
            mainJangadId: this.state.props.data.mainJangadId,
            jangadId: this.state.props.data.jangadId,
            dataEntryStockId: this.state.props.data.dataEntryStockId,
            graderStockId: this.state.props.data.graderStockId,
            assignGraderToFillerInWardId: x.assignGraderToFillerInWardId,
            stockDataEntryInWardId: x.stockDataEntryInWardId,
          };
        }),
      };
      const data = await addFillerStock(temp);
    }
    this.state.history.goBack();
  }

  async reject(values) {
    const data = await updateGraderAssignStock({
      id: this.state.stockList[0].assignGraderToFillerStockId,
      data: {
        fillerStatus: "R",
      },
    });
    this.state.history.goBack();
  }

  async componentDidMount() {
    const inclusion = await getInclusion();
    const filler = await getUserApi({
      factoryId: this.state.props.data.jangad.factoryId,
      roleId: "ROLE0000003",
    });
    this.setState(
      {
        fillerList: filler.data.users,
        inclusionList: [
          { label: "NONE", value: "" },
          ...inclusion.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
      },
      () =>
        this.setState({
          stockList: this.state.stockList.map(x => {
            return {
              ...x,
              inclusionId:
                x.inclusionId == null
                  ? []
                  : this.state.inclusionList.filter(y =>
                      x.inclusionId.includes(y.value)
                    ),
            };
          }),
        })
    );
  }

  async getStockList() {
    const stock = await getCubeBelts();
    this.setState({
      stockList: stock.data
        .reduce((prev, current) => {
          return prev.cycle > current.cycle ? prev : current;
        })
        .dataEntryStock.graderStock.assignGraderToFillerStocks.reduce(
          (prev, current) => {
            return prev.cycle > current.cycle ? prev : current;
          }
        )
        .assignGraderToFillerInWards.map((x, index) => {
          return {
            id: index + 1,
            assignGraderToFillerStockId: x.assignGraderToFillerStockId,
            assignGraderToFillerInWardId: x.id,
            remarks: x.nextRemarks,
            srNo: x.stockDataEntryInWard.srNo,
            pieces: x.stockDataEntryInWard.pieces,
            inclusionId: x.stockGraderInWard.inclusionId,
            shape: x.stockGraderInWard.shape.name,
            processId: x.processId,
          };
        }),
    });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    document.title = "filler flow";
    //meta title
    this.columns1 = [
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
      },

      {
        dataField: "shape",
        text: `${this.props.t("Shape")}`,
        type: "text",
        footer: "",
      },
      {
        dataField: "inclusionId",
        text: `${this.props.t("Inclusion")}`,
        type: "text",
        formatter: (cell, row) => {
          if (
            row?.inclusionId?.length &&
            typeof row?.inclusionId[0] != "number"
          ) {
            let temp = [];
            temp = row?.inclusionId.map(x =>
              typeof x == "number" ? x : x?.value
            );
            return this.state.inclusionList
              .filter(x => temp.includes(x?.value))
              .map(x => (
                <span key={x?.value} className="border border-1 px-1 py-1 m-1">
                  {x.label}
                </span>
              ));
          } else {
            return "NONE";
          }
        },
        footer: "",
      },
      {
        dataField: "processId",
        text: `${this.props.t("Assign Process")}`,
        type: "text",
        footer: "",
      },
      {
        dataField: "remarks",
        text: `${this.props.t("Remarks")}`,
        footer: "",
      },
      {
        dataField: "edit",
        text: `${this.props.t("Edit Data")}`,
        footer: "",
        editable: true,

        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          return (
            <div className="btn-group">
              {!this.state.notEditableRows.includes(row.id) ? (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setState({
                      notEditableRows: [...this.state.notEditableRows, row.id],
                    });
                  }}
                >
                  <img src="images/dashboard-images/print.svg"></img>
                </span>
              ) : (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    if (
                      this.state.notEditableRows?.length ===
                      this.state.stockList?.length
                    )
                      this.setState({
                        notEditableRows: this.state.notEditableRows.filter(
                          x => x != row.id
                        ),
                      });
                  }}
                >
                  <img src="images/dashboard-images/edit.svg"></img>
                </span>
              )}
            </div>
          );
        },
        formatter: (cell, row, rowIndex) => (
          <div className="btn-group">
            {!this.state.notEditableRows.includes(row.id) ? (
              <span
                className="border-0 rounded ms-2"
                onClick={() => {
                  this.setState({
                    notEditableRows: [...this.state.notEditableRows, row.id],
                  });
                }}
              >
                <img src="images/dashboard-images/print.svg"></img>
              </span>
            ) : (
              <span
                className="border-0 rounded ms-2"
                onClick={() => {
                  if (
                    this.state.notEditableRows?.length ===
                    this.state.stockList?.length
                  )
                    this.setState({
                      notEditableRows: this.state.notEditableRows.filter(
                        x => x != row.id
                      ),
                    });
                }}
              >
                <img src="images/dashboard-images/edit.svg"></img>
              </span>
            )}
          </div>
        ),
      },
    ];
    document.title = "add party";
    const { history } = this.props;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={this.props.t("EDIT VERIFY & ACCEPT")}
            />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  id: this.state.props.data.mainJangadId,
                  name: this.state.props.data.mainJangad.name,
                  // partyName: this.state.props.data.mainJangad.party.name,
                  unitName: this.state.props.data.jangad.factoryId,
                  category: this.state.props.data.mainJangad.category.name,
                  weight: this.state.props.data.jangad.weight,
                  pieces: this.state.props.data.jangad.pieces,
                  fillerUserId: JSON.parse(localStorage.getItem("authUser")).id,
                  graderRemarks: this.state.props.data.remarks,
                  remarks: this.state.props.data.nextRemarks,
                }}
                validationSchema={Yup.object().shape({
                  id: Yup.string().required("This value is required"),
                  name: Yup.string().required("This value is required"),
                  // partyName: Yup.string().required("This value is required"),
                  unitName: Yup.string().required("This value is required"),
                  weight: Yup.string().required("This value is required"),
                  pieces: Yup.string().required("This value is required"),
                  fillerUserId: Yup.string().required("This value is required"),
                  graderremarks: Yup.string().max(512).nullable().notRequired(),
                  remarks: Yup.string().max(512).nullable().notRequired(),
                })}
                onSubmit={values => {
                  JSON.stringify(values, null, 4);
                  history.push("/filler-stock-list");
                }}
              >
                {({ errors, status, touched, values, validateForm }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <CardBody>
                        <div className="d-lg-flex d-block justify-content-between">
                          <div>
                            <h4 className="pb-3 text-black fw-bold">
                              {this.props.t("EDIT VERIFY & ACCEPT")}
                            </h4>
                          </div>
                          {/* <div className="mb-3 row">
                            <Label
                              htmlFor="date"
                              className="col-12 col-sm-2 col-lg-4"
                            >
                              <h5 className="fs-5 fw-bold text-black">Date:</h5>
                            </Label>
                            <div className="col-12 col-sm-5 col-lg-8">
                              <Field
                                className={
                                  "border-0 fs-5" +
                                  (errors.date && touched.date
                                    ? " is-invalid"
                                    : "")
                                }
                                type="date"
                                name="date"
                              />
                              <ErrorMessage
                                name="date"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div> */}
                        </div>
                        {/* <div className="mb-3 row">
                          <Label
                            htmlFor="id"
                            className="col-md-2 col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Jangad Id")}
                            </h5>
                          </Label>
                          <div className="col-md-10">
                            <Field
                              className={
                                "form-control fs-5" +
                                (errors.id && touched.id ? " is-invalid" : "")
                              }
                              disabled={this.state.props.data ? true : false}
                              type="text"
                              name="id"
                              placeholder="JANGAD0000123"
                            />
                            <ErrorMessage
                              name="id"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div> */}
                        <div className="mb-3 row">
                          <Label
                            htmlFor="name"
                            className="col-md-2 col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Jangad Id")}
                            </h5>
                          </Label>
                          <div className="col-md-10">
                            <Field
                              className={
                                "form-control fs-5" +
                                (errors.name && touched.name
                                  ? " is-invalid"
                                  : "")
                              }
                              disabled={this.state.props.data ? true : false}
                              type="text"
                              name="name"
                              placeholder="JANGAD0000123"
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        {/* <div className="mb-3 row">
                          <Label
                            htmlFor="partyName"
                            className="col-md-2 col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Party Name")}
                            </h5>
                          </Label>
                          <div className="col-md-10">
                            <Field
                              className={
                                "form-control fs-5" +
                                (errors.partyName && touched.partyName
                                  ? " is-invalid"
                                  : "")
                              }
                              disabled={this.state.props.data ? true : false}
                              type="text"
                              name="partyName"
                              placeholder="XYZ Diamond"
                            />
                            <ErrorMessage
                              name="partyName"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div> */}
                        <div className="mb-3 row">
                          <Label
                            htmlFor="unitName"
                            className="col-md-2 col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Unit Name")}
                            </h5>
                          </Label>
                          <div className="col-md-10">
                            <Field
                              className={
                                "form-control fs-5" +
                                (errors.unitName && touched.unitName
                                  ? " is-invalid"
                                  : "")
                              }
                              disabled={this.state.props.data ? true : false}
                              type="text"
                              name="unitName"
                              placeholder="20.25 CT"
                            />
                            <ErrorMessage
                              name="unitName"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <Label
                            htmlFor="fillerUserId"
                            className="col-md-2 col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Filler Name")}
                            </h5>
                          </Label>
                          <div className="col-md-10">
                            <Field
                              className={
                                "form-control fs-5" +
                                (errors.fillerUserId && touched.fillerUserId
                                  ? " is-invalid"
                                  : "")
                              }
                              disabled={this.state.props.data ? true : false}
                              name="fillerUserId"
                              as="select"
                            >
                              <option value="" disabled>
                                select
                              </option>
                              {this.state.fillerList?.map(x => (
                                <option key={x.id} value={x.id}>
                                  {x.name}
                                </option>
                              ))}
                            </Field>
                            <ErrorMessage
                              name="fillerUserId"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <Label
                            htmlFor="category"
                            className="col-md-2 col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Diamond Category")}
                            </h5>
                          </Label>
                          <div className="col-md-10">
                            <Field
                              className={
                                "form-control fs-5" +
                                (errors.category && touched.category
                                  ? " is-invalid"
                                  : "")
                              }
                              disabled={this.state.props.data ? true : false}
                              type="text"
                              name="category"
                              placeholder="20.25 CT"
                            />
                            <ErrorMessage
                              name="category"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <Label
                            htmlFor="pieces"
                            className="col-md-2 col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Total No of Pieces")}
                            </h5>
                          </Label>
                          <div className="col-md-10">
                            <Field
                              className={
                                "form-control fs-5" +
                                (errors.pieces && touched.pieces
                                  ? " is-invalid"
                                  : "")
                              }
                              disabled={this.state.props.data ? true : false}
                              type="text"
                              value={(() => {
                                return ShowDiffenence(
                                  this.state.props.data?.dataEntryStock.stockDataEntryInWards,
                                  this.state.props.data.jangad,
                                  "pieces"
                                );
                              })()}
                              onWheel={e => e.target.blur()}
                              name="pieces"
                              placeholder="2001"
                            />
                            <ErrorMessage
                              name="pieces"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <Label
                            htmlFor="weight"
                            className="col-md-2 col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Total Weight")}
                            </h5>
                          </Label>
                          <div className="col-md-10">
                            <Field
                              className={
                                "form-control fs-5" +
                                (errors.weight && touched.weight
                                  ? " is-invalid"
                                  : "")
                              }
                              disabled={this.state.props.data ? true : false}
                              type="text"
                              onWheel={e => e.target.blur()}
                              value={(() => {
                                return ShowDiffenence(
                                  this.state.props.data?.dataEntryStock.stockDataEntryInWards,
                                  this.state.props.data.jangad,
                                  "weight"
                                );
                              })()}
                              name="weight"
                              placeholder="20.25 CT"
                            />
                            <ErrorMessage
                              name="weight"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <Label
                            htmlFor="graderRemarks"
                            className="col-md-2 col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Grader Notes")}
                            </h5>
                          </Label>
                          <div className="col-md-10">
                            <Field
                              className={
                                "form-control fs-5" +
                                (errors.graderRemarks && touched.graderRemarks
                                  ? " is-invalid"
                                  : "")
                              }
                              disabled={this.state.props.data ? true : false}
                              as="textarea"
                              rows="5"
                              name="graderRemarks"
                              placeholder="2001"
                            />
                            <ErrorMessage
                              name="graderRemarks"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <Label
                            htmlFor="remarks"
                            className="col-md-2 col-form-label"
                          >
                            <h5 className="text-secondary fw-bold">
                              {this.props.t("Filler Notes")}
                            </h5>
                          </Label>
                          <div className="col-md-10">
                            <Field
                              className={
                                "form-control fs-5" +
                                (errors.remarks && touched.remarks
                                  ? " is-invalid"
                                  : "")
                              }
                              disabled={this.state.props.data ? true : false}
                              as="textarea"
                              rows="5"
                              name="remarks"
                              placeholder="2001"
                            />
                            <ErrorMessage
                              name="remarks"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                      </CardBody>
                      {/* {this.state.props.isEdit != 1 ? (
                        ""
                      ) : (
                        <div className="row px-3 pt-3">
                          <div>
                            <h3 className="fw-bold pb-3 text-black">{this.props.t("Assign Stock Details")}</h3>
                          </div>
                          <div className="table-responsive">
                            <BootstrapTable
                              keyField="id"
                              classes="foo"
                              headerClasses="background-light fs-5"
                              footerClasses="background-light fs-5"
                              data={this.state.stockList}
                              columns={this.columns1}
                              cellEdit={cellEditFactory({
                                mode: "click",
                                blurToSave: true,
                                nonEditableRows: () =>
                                  this.state.notEditableRows,
                              })}
                            />
                          </div>
                        </div>
                      )} */}

                      <div className="row px-3 pt-4">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                            {this.props.t("Assign Stock Details Summary")}
                          </h3>
                        </div>

                        <div className="table-responsive">
                          <BootstrapTable
                            classes="foo"
                            keyField="id"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.state.stockList}
                            columns={[...this.columns1].slice(0, -1)}
                          />
                        </div>
                      </div>
                      <div className="col-md-12 text-center text-md-end my-4 pe-lg-3">
                        {this.state.props.isEdit == 1 && (
                          <>
                            <Button
                              color="white"
                              className="fs-4 border-0 text-primary me-0 me-md-5 fw-bold"
                              type="submit"
                              onClick={async () => {
                                await validateForm()
                                  .then(data => {
                                    if (Object.keys(data)?.length == 0) {
                                      this.handleSubmit(event, values);
                                    }
                                  })
                                  .catch(err => console.log("err =>", err));
                              }}
                            >
                              Accept
                            </Button>
                            <Button
                              color="primary"
                              onClick={() => this.reject(event, values)}
                              className="fs-4 px-5"
                            >
                              Reject
                            </Button>
                          </>
                        )}
                        {this.state.props.isEdit == 3 && (
                          <Link to="/filler-dashboard">
                            <Button color="primary" className="fs-4 px-5">
                              Back
                            </Button>
                          </Link>
                        )}
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(FillerEditVerifyAndAccept);
